<template>
    <div class="full">
        <div class="waveWrapper waveAnimation">
            <div class="title1">
                <h2>电梯云</h2>
            </div>
            <div class="title2">
                <h4>
                    一站式电梯安全管理平台
                </h4>
            </div>
            <!--<div class="waveWrapperInner bgTop">-->
            <!--&lt;!&ndash;<div class="wave waveTop"></div>&ndash;&gt;-->
            <!--</div>-->
            <div class="waveWrapperInner bgMiddle">
                <div class="wave waveMiddle"></div>
            </div>
            <div class="waveWrapperInner bgBottom">
                <div class="wave waveBottom"></div>
            </div>
            <!-- 底部登录 -->
            <div class="login-box">
                <Form style="width: 70%;margin-left: 15%;margin-top: 10%" v-if="!changeForm" label-position="right" :rules="getRules"  ref="modal" :model="modal">
                    <FormItem  :label="$t('l.mobile')" prop="username" :label-width="65">
                        <Input  prefix="ios-contact" v-model="modal.username" placeholder="请输入用户名或手机号"/>
                    </FormItem>
                    <FormItem class="password-form-item"  :label="$t('l.pwd')" prop="password" :label-width="65">
                        <Input style="height: 20px;line-height: 20px;" prefix="ios-lock" @on-click="modal.showPassword=!modal.showPassword" :suffix="modal.showPassword?'ios-eye':'ios-eye-off'" v-model="modal.password" :type="modal.showPassword?'text':'password'" placeholder="请输入密码"/>
                    </FormItem>
                  <FormItem :label="$t('l.captcha')"  class="FormItem" v-if="modal.showCaptcha">
                    <img :src="modal.captchaImgUrl" alt="" class="margin-right-20">
                    <Input style="width: 100px" class="form-input" type="text" v-model="modal.captcha"/>
                  </FormItem>
                    <FormItem>
                        <div class="forget-box">
                            <span></span>
                            <!--<Checkbox @on-change="changeCheckbox" v-model="modal.single">记住密码</Checkbox>-->
                            <span class="forget-password" @click="changeForm=!changeForm">忘记密码</span>
                        </div>
                    </FormItem>
                    <FormItem>
                        <Button style="width: 100%" @click="submit('modal')" :loading="modal.loading" type="primary">登录</Button>
                    </FormItem>
                </Form>
                <!-- 忘记密码 -->
                <Form :rules="forgetRules" style="width: 70%;margin-left: 15%;margin-top: 10%" v-else   ref="forget" :model="forget">
                    <FormItem :label="$t('l.mobile')" prop="mobile" >
                        <Input  prefix="ios-call" v-model="forget.mobile" placeholder="请输入手机号"/>
                    </FormItem>
                    <FormItem :label="$t('l.captcha')" prop="captcha">
                        <div class="form-con-form-div">
                            <input class="input-captcha" type="text" v-model="forget.captcha" :placeholder="$t('l.remark4')">
                            <Button :loading="loading" :style="{backgroundColor:start!=$t('l.get_captcha')?'#aaa':'#5e30c3'}"
                                    :disabled="start!=$t('l.get_captcha')" style="width: 35%" class="button-captcha" type="info"
                                    long @click="getCaptcha">{{start}}</Button>
                        </div>
                    </FormItem>
                    <FormItem class="password-form-item" :rules="{required:true,message:$t('l.remark9'),trigger:'blur'}" :label="$t('l.pwd_new')" prop="npsw">
                        <Input style="height: 20px;line-height: 20px;" prefix="ios-lock" v-model="forget.npsw" type='password' placeholder="请输入新密码"/>
                    </FormItem>
                    <FormItem>
                        <div class="forget-box">
                            <span></span>
                            <span class="forget-password" @click="changeForm=!changeForm">返回登录</span>
                        </div>
                    </FormItem>
                    <FormItem >
                        <Button style="width: 100%" @click="confirm('forget')" :loading="forget.loading" type="primary">提交</Button>
                    </FormItem>
                </Form>
                <div class="download-img">
                    <img class="full" src="/images/qrcode/download.png" alt="">
                    <div style="display: flex;justify-content: center">电梯云APP</div>
                </div>
            </div>

            <div class="bg"></div>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js';
    export default {
        name: "m_login",
        data(){
            return {
                modal:{
                    username:'',
                    password:'',
                    showPassword:false,
                    single:false,
                    loading:false,
                  captcha:"",
                  showCaptcha:false,
                  captchaImgUrl:'',
                },
                changeForm:false,
                forget:{
                    mobile:'',
                    captcha:'',
                    npsw:'',
                    loading:false
                },
                start:this.$t('l.get_captcha'),
                loading:false
            }
        },
        methods:{

          getLoginCaptcha(){
            util.ajax.get('/login_captcha', { }).then(res =>{
              if(!res.code){
                this.modal.showCaptcha = true;
                this.modal.loading = false;
                this.modal.captcha = "";
                localStorage.setItem('captchaKey',res.data.captchaKey);
                this.modal.captchaImgUrl = res.data.captchaBase64;
              }
            })
          },
            submit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.modal.loading = true;
                        util.ajax.get('/login', {
                            params: {
                                username: this.modal.username,
                                password: this.modal.password,
                                isApi:true,
                                captchaKey:localStorage.getItem('captchaKey'),  // 验证码的key
                                code:this.modal.captcha  // 验证码
                            }
                        }).then((res) => {
                            let loginUser = res.data;  // userinfo
                            this.modal.loading = false;
                            if (res.code) {
                              let data = res.data;
                              // console.log("登录失败data===> :",data);
                              localStorage.setItem('flc',data.count);  // 失败登录次数
                              if(data.count > 2){  // 获取登录失败captcha
                                this.getLoginCaptcha();
                              }else{
                                this.modal.loading = false;
                              }
                            } else {
                                // 登录成功
                                this.$Message.success(this.$t("l.success"))
                                if (loginUser.token) {
                                    localStorage.setItem('token', loginUser.token);
                                    util.getAuth(1).then(_ => {
                                        this.$router.push({
                                            name: 'm_home'
                                        });
                                    });
                                }
                            }
                        }).catch(e => {
                            this.modal.loading = false;
                        });
                    }
                });
            },
            confirm(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.forget.loading=true;
                        var param = {
                            mobile : this.forget.mobile,
                            password : this.forget.npsw,
                            captcha : this.forget.captcha
                        }
                        util.ajax.post('/reset_password',param).then((res) => {
                            this.forget.loading=false;
                            if (!res.code) {
                                this.$Message.success(this.$t('l.edit_success'))
                                this.changeForm = !this.changeForm
                            }
                        });
                    }
                });
            },
            // changeCheckbox(v){
            //     localStorage.setItem("rememberPassword",v)
            // },
            getCaptcha() {
                if (!this.forget.mobile) {
                    this.$Message.error(this.$t('l.remark3'))
                    return
                }
                this.loading=true;
                util.ajax.get('/captcha',{
                    params:{
                        data:{
                            company:"【"+this.$t('l.dty_platform')+"】",
                            mobile:this.forget.mobile,
                            language:"zh"
                        }
                    }
                }).then(res => {
                    this.loading=false;
                    if (!res.code) {
                        this.start = 60;
                        this.$Message.success(this.$t('l.hint4'));
                        var timer = setInterval(() => {
                            if (this.start == 0) {
                                clearInterval(timer)
                                this.start =  this.$t('l.get_captcha');
                            } else {
                                this.start--;
                            }
                        }, 1000)
                    }
                })
            },
        },
        computed:{
            getRules(){
                return {
                    username: [{
                        required: true,
                        message: this.$t('l.hint1'),
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: this.$t('l.remark118'),
                        trigger: 'blur'
                    }],
                }
            },
            forgetRules(){
                return {
                    mobile: [{required: true, message: this.$t('l.hint2'), trigger: 'blur'}],
                    captcha: [{required: true, message:this.$t('l.hint3'), trigger: 'blur'}]
                }
            },
        },
        created(){
            // this.modal.single = !!localStorage.getItem("rememberPassword");
            // if (this.modal.single) {
            //
            // }
        },
    }
</script>

<style scoped lang="less">
    @keyframes move_wave {
        0% {
            transform: translateX(0) translateZ(0) scaleY(1)
        }
        50% {
            transform: translateX(-25%) translateZ(0) scaleY(0.55)
        }
        100% {
            transform: translateX(-50%) translateZ(0) scaleY(1)
        }
    }
    .input-captcha {
        width: 35%;
        padding-left: 12px;
        border: none;
        border-bottom: 1px solid #d3d3d3;
        box-shadow: 0 0 600px #fff inset;
        background-color: transparent;
        height: 24px;
        line-height: 24px;
        color: #7f8c8d;
    }
    .button-captcha {
        color: #fff;
        border: none;
        background-color: #33ccff;
        margin-left: 10px;
    }
    .title1,.title2{
        position: absolute;
        z-index: 16;
        color: #fff;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        font-family: serif;
        width: 100%;
        margin-top: 10%;
    }
    .title2{
        margin-top: 20%;
    }
    .download-img {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .download-img > img {
        width: 100px;
        height: 100px;
        margin-left: calc(50% - 50px);
    }

    .waveWrapper {
        overflow: hidden;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        z-index: 4;
    }
    .bg{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-image: url("../../public/images/m_login1.jpg");
        background-size: 100% 80%;
        z-index: 9;
    }
    .waveWrapperInner {
        position: absolute;
        width: 100%;
        overflow: hidden;
        height: 45%;
        background-image: linear-gradient(to top,#fff 20%, #0abde3 80%);
    }
    .login-box{
        position: absolute;
        width: 100%;
        overflow: hidden;
        height: 55%;
        top: 45%;
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: center;*/
        background-color: #fff;
        z-index: 10;
    }
    .bgTop {
        z-index: 15;
        opacity: 0.3;
    }
    .bgMiddle {
        z-index: 10;
        opacity: 0.35;
    }
    .bgBottom {
        z-index: 5;
    }
    .wave {
        position: absolute;
        left: 0;
        width: 200%;
        height: 100%;
        background-repeat: repeat no-repeat;
        background-position: 0 bottom;
        transform-origin: center bottom;
    }
    /*.waveTop {*/
    /*background-size: 50% 25px;*/
    /*background-image: url('../../public/images/mobile/login/wave-top.png')*/
    /*}*/
    /*.waveAnimation .waveTop {*/
    /*animation: move-wave 3s;*/
    /*-webkit-animation: move-wave 3s;*/
    /*-webkit-animation-delay: 1s;*/
    /*animation-delay: 1s;*/
    /*}*/
    /*.waveMiddle {*/
    /*background-size: 50% 25px;*/
    /*background-image: url('../../public/images/mobile/login/wave-mid.png')*/
    /*}*/
    /*.waveAnimation .waveMiddle {*/
    /*animation: move_wave 10s linear infinite;*/
    /*}*/
    /*.waveBottom {*/
    /*background-size: 50% 25px;*/
    /*background-image: url('../../public/images/mobile/login/wave-bot.png')*/
    /*}*/
    /*.waveAnimation .waveBottom {*/
    /*animation: move_wave 15s linear infinite;*/
    /*}*/
    .forget-password{
        color: #57abe9;
    }
    .forget-box{
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

</style>